module.exports = __webpack_public_path__ + "img/zhengzhou-zz.9b19c44b.png";